import type { ReactNode } from 'react'
import Badge from '../ui/Badge'
import TimeRangePicker from './TimeRangePicker'
import type { TimeRange } from '../../services/analyticsService'

interface AnalyticsShellProps {
  eyebrow: string
  title: string
  description: string
  timeRange?: TimeRange
  onTimeRangeChange?: (range: TimeRange) => void
  actions?: ReactNode
  children: ReactNode
}

export default function AnalyticsShell({
  eyebrow,
  title,
  description,
  timeRange,
  onTimeRangeChange,
  actions,
  children,
}: AnalyticsShellProps) {
  return (
    <div className="dashboard-page">
      <header className="dashboard-header">
        <div className="flex flex-col gap-5 xl:flex-row xl:items-end xl:justify-between">
          <div className="max-w-4xl">
            <Badge variant="gradient" size="sm">{eyebrow}</Badge>
            <h1 className="mt-3 text-3xl font-bold tracking-tight text-white md:text-5xl text-balance">{title}</h1>
            <p className="mt-2 max-w-3xl text-base leading-relaxed text-gray-400 md:text-lg">{description}</p>
          </div>
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
            {timeRange && onTimeRangeChange && (
              <TimeRangePicker value={timeRange} onChange={onTimeRangeChange} />
            )}
            {actions}
          </div>
        </div>
      </header>
      <main className="dashboard-content space-y-5">
        {children}
      </main>
    </div>
  )
}
